import { Col, Container, Row } from 'react-bootstrap';
import Button from '../../../../components/Button';
import { ButtonContainer } from '../../../../components/Form';
import Loader from '../../../../components/Loader';
import OpacityAnimation from '../../../../components/OpacityAnimation';
import PageHeader from '../../../../components/PageHeader';
import Sidebar from '../../../../components/Sidebar';
import Transitions from '../../../../components/Transition';
import BillingAddress from './components/BillingAddress';
import CompanyAddress from './components/CompanyAddress';
import CompanyData from './components/CompanyData';
import ContactAndAccess from './components/ContactAndAccess';
import useNewBranch from './useNewBranch';

export default function NewBranch() {
  const {
    isLoading,
    getErrorMessageByFieldName,
    cpf,
    handleCpfChange,
    cnpj,
    handleCnpjChange,
    cnpjPagto,
    handleCnpjPagtoChange,
    pagadorNFSeparada,
    setPagadorNFSeparada,
    password,
    handlePasswordChange,
    passwordConfirmation,
    handlePasswordConfirmationChange,
    email,
    handleEmailChange,
    createBranch,
    isReadyToCreateBranch,
    emailConfirmation,
    handleEmailConfirmationChange,
    companyName,
    handleCompanyNameChange,
    fantasyName,
    handleFantasyNameChange,
    employeesQty,
    handleEmployeesQtyChange,
    stateRegistration,
    handleStateRegistrationChange,
    municipalRegistration,
    handleMunicipalRegistrationChange,
    companyCellphone,
    handleCompanyCellphoneChange,
    cep,
    handleCepChange,
    uf,
    city,
    district,
    street,
    handleNumberChange,
    number,
    handleComplementChange,
    complement,
    setBillingAddres,
    billingAddress,
    billingCep,
    handleBillingCepChange,
    billingUf,
    billingCity,
    billingDistrict,
    billingStreet,
    handleBillingNumberChange,
    billingNumber,
    handleBillingComplementChange,
    billingComplement,
    name,
    handleNameChange,
    contactCellphone,
    handleContactCellphoneChange,
    isGettingCepData,
    isGettingBillingCepData,
  } = useNewBranch();

  return (
    <>
      <Sidebar active="Company" />
      <Transitions>
        <Loader isLoading={isLoading} />
        <PageHeader
          title={'Adicionar Filial'}
          link={'/company/branches'}
        />
        <Container>
          <Row xs={1} md={1} lg={1}>
            <Col>
              <OpacityAnimation>
                <CompanyData
                  getErrorMessageByFieldName={getErrorMessageByFieldName}
                  cnpj={cnpj}
                  handleCnpjChange={handleCnpjChange}
                  cnpjPagto={cnpjPagto}
                  handleCnpjPagtoChange={handleCnpjPagtoChange}
                  pagadorNFSeparada={pagadorNFSeparada}
                  setPagadorNFSeparada={setPagadorNFSeparada}
                  companyName={companyName}
                  handleCompanyNameChange={handleCompanyNameChange}
                  fantasyName={fantasyName}
                  handleFantasyNameChange={handleFantasyNameChange}
                  employeesQty={employeesQty}
                  handleEmployeesQtyChange={handleEmployeesQtyChange}
                  stateRegistration={stateRegistration}
                  handleStateRegistrationChange={handleStateRegistrationChange}
                  municipalRegistration={municipalRegistration}
                  handleMunicipalRegistrationChange={handleMunicipalRegistrationChange}
                  companyCellphone={companyCellphone}
                  handleCompanyCellphoneChange={handleCompanyCellphoneChange}
                />
              </OpacityAnimation>
            </Col>

            <Col>
              <OpacityAnimation>
                <CompanyAddress
                  getErrorMessageByFieldName={getErrorMessageByFieldName}
                  isGettingCepData={isGettingCepData}
                  cep={cep}
                  handleCepChange={handleCepChange}
                  uf={uf}
                  city={city}
                  district={district}
                  street={street}
                  handleNumberChange={handleNumberChange}
                  number={number}
                  handleComplementChange={handleComplementChange}
                  complement={complement}
                />
              </OpacityAnimation>
            </Col>

            <Col>
              <OpacityAnimation>
                <BillingAddress
                  billingAddress={billingAddress}
                  setBillingAddres={setBillingAddres}
                  getErrorMessageByFieldName={getErrorMessageByFieldName}
                  isGettingBillingCepData={isGettingBillingCepData}
                  billingCep={billingCep}
                  handleBillingCepChange={handleBillingCepChange}
                  billingUf={billingUf}
                  billingCity={billingCity}
                  billingDistrict={billingDistrict}
                  billingStreet={billingStreet}
                  handleBillingNumberChange={handleBillingNumberChange}
                  billingNumber={billingNumber}
                  handleBillingComplementChange={handleBillingComplementChange}
                  billingComplement={billingComplement}
                />
              </OpacityAnimation>
            </Col>

            <Col>
              <OpacityAnimation>
                <ContactAndAccess
                  getErrorMessageByFieldName={getErrorMessageByFieldName}
                  cpf={cpf}
                  handleCpfChange={handleCpfChange}
                  name={name}
                  handleNameChange={handleNameChange}
                  contactCellphone={contactCellphone}
                  handleContactCellphoneChange={handleContactCellphoneChange}
                  email={email}
                  handleEmailChange={handleEmailChange}
                  emailConfirmation={emailConfirmation}
                  handleEmailConfirmationChange={handleEmailConfirmationChange}
                  password={password}
                  handlePasswordChange={handlePasswordChange}
                  passwordConfirmation={passwordConfirmation}
                  handlePasswordConfirmationChange={handlePasswordConfirmationChange}
                />
              </OpacityAnimation>
            </Col>
          </Row>

          <ButtonContainer>
            <Button disabled={!isReadyToCreateBranch} onClick={() => createBranch()}>
              {`Adicionar Filial ${name ?? ''}`}
            </Button>
          </ButtonContainer>
        </Container>
      </Transitions>
    </>
  );
}
